var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRockfallsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_340_2898)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 30.5,
    fill: "white",
    stroke: "#1E4161",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_340_2898",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 61,
    height: 61
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 30.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_340_2898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5 29.5C51.5 25.1 55.1667 11.6667 56.5 5.5L65 8.5L64 68H6L2.5 48.5L12.5 43.5L19.5 47.5L24.5 57C24.8883 54.541 26.0001 49.4488 27.7888 45.0481L24.5 44.5L26 35.5L34.5 34V37.0062C38.7394 34.6363 44.1374 33.1989 47.5 29.5Z",
    fill: "#1E4161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5 15.5C49.5 15 43.5 11 43.5 11L41.5 15L44.5 17.5C44.5 17.5 45.5 16 47.5 15.5Z",
    fill: "#1E4161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 19.5L41.5 22.5L39 26.5L30.5 31.5V22.5L33 19.5Z",
    fill: "#1E4161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 38.5L13 35L17.5 34L16.5 38.5H13.5Z",
    fill: "#1E4161"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_340_2898",
    x: 0,
    y: 0,
    width: 67,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_340_2898"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_340_2898",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRockfallsIcon);
export default __webpack_public_path__ + "static/media/rockfallsIcon.09554e43e092a41d567f4e4aa6b3a398.svg";
export { ForwardRef as ReactComponent };